import { baseUrl } from "./RemindMeAPIServices"


export const transcribeAudio = async (blob: Blob): Promise<string | null> => {
    const formData = new FormData();
    const file = new File([blob], "recording.wav", { type: "audio/mp4" })
    formData.append("audio", file)
    const apiEndpointSpeechToText = "https://remindmepwa.thoughtlinetech.net/speech-to-text";
    const apiEndpointResult = "https://remindmepwa.thoughtlinetech.net/result/";

    try {
        const response = await fetch(apiEndpointSpeechToText, {
            method: 'POST',
            body: formData,
        });

        const responseText = await response.text();
        const responseData = JSON.parse(responseText);

        if (response.ok && responseData.task_id) {
            const taskId = responseData.task_id;
            let transcriptionComplete = false;
            let transcript = '';

            while (!transcriptionComplete) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                const transcriptResponse = await fetch(`${apiEndpointResult}${taskId}`);
                const transcriptResponseText = await transcriptResponse.text();
                const transcriptData = JSON.parse(transcriptResponseText);

                if (transcriptData.status === 'failed') {
                    console.warn('Transcription failed:', transcriptData);
                    transcriptionComplete = true;
                } else if (transcriptData.status === 'completed') {
                    transcript = transcriptData.transcript;
                    transcriptionComplete = true;
                } else {
                }
            }

            return transcript;
        } else {
            throw new Error('Failed to start transcription process.');
        }
    } catch (error) {
        console.error('Error during transcription:', error);
        return null;
    }
};


export const sendEmailVoice = async (
    selectedEmail: string,
    audioData: string,
    featureType: string,
    companyId: number,
    deviceId: string,
    transcript: string
) => {
    const apiEndpoint = `${baseUrl}/send-voice-email`;

    try {
        const response = await fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                company_id: companyId,
                to_email: selectedEmail,
                voice_content: audioData,
                feature_type: featureType,
                device_id: deviceId,
                voice_content_as_text: transcript,
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to send voice email');
        }

        const responseData = await response.json();

        return responseData;
    } catch (error) {
        console.error('Error sending voice email:', error);
        throw error;
    }
};
